import React, { useEffect } from 'react'
import { useSponsorsContext } from '../context/sponsors/SponsorsProvider'
import useSponsorsActions from '../hooks/useSponsorsActions'
import { Link } from 'react-router-dom'
import Breadcrumb from '../../core/components/UI/Breadcrumb'
import ButtonSponsorsOptions from '../components/sponsors-page/ButtonSponsorsOptions'
import LoaderSponsorsGrid from '../components/sponsors-page/LoaderSponsorsGrid'
import Pagination from '../../core/components/UI/Pagination'
import SponsorsGrid from '../components/sponsors-page/SponsorsGrid'

const links = [
  {
    id: 1,
    label: 'الرعاة',
    isActive: true,
    to: '/sponsors',
  },
]
export default function SponsorsPage() {
  const { sponsorsState } = useSponsorsContext()
  const { getSponsors } = useSponsorsActions()

  useEffect(() => {
    getSponsors()
  }, [])

  return (
    <>
      <Breadcrumb links={links} />
      <div className="flex">
        <Link
          to={`/sponsors/create`}
          className="flex bg-primary-600 px-4 py-2 font-bold text-white hover:bg-primary-500"
        >
          إضافة راعي
        </Link>
      </div>
      {sponsorsState.isLoading ? (
        <LoaderSponsorsGrid />
      ) : (
        <SponsorsGrid sponsors={sponsorsState.sponsors} />
      )}
      <Pagination pagination={sponsorsState.pagination} />
    </>
  )
}
